import * as React from 'react';
import { SVGProps } from 'react';

export const SubmissionSuccessSubmitSVG = (props: SVGProps<SVGSVGElement>) => (
    <svg width={364} height={225} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#a)">
            <path
                opacity={0.16}
                d="M340.3 165.7c-2.9 0-5.7.6-8.2 1.5-6.1-7.1-15.2-11.6-25.3-11.6-18.5 0-33.5 15-33.5 33.5h90.6c-.1-12.9-10.7-23.4-23.6-23.4Z"
                fill="#2278ED"
            />
            <path
                opacity={0.4}
                d="m191.9 5 1.8-4.4c.3-.8 1.5-.8 1.8 0l1.8 4.4c.1.2.3.4.5.5l4.4 1.8c.8.3.8 1.5 0 1.8l-4.4 1.8c-.2.1-.4.3-.5.5l-1.8 4.4c-.3.8-1.5.8-1.8 0l-1.8-4.4c-.1-.2-.3-.4-.5-.5L187 9.1c-.8-.3-.8-1.5 0-1.8l4.4-1.8c.2-.1.4-.3.5-.5Z"
                fill="#FDC443"
            />
            <path
                d="M46.2 133.2v16M46.2 173.2v16M18.2 161.2h16M58.2 161.2h16M26.4 141.4l11.3 11.3M54.7 169.7 66 181M26.4 181l11.3-11.3M54.7 152.7 66 141.4"
                stroke="#FDC443"
                strokeWidth={4}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M281.2 17.2V40M281.2 74.3v22.9M241.2 57.2h22.9M298.3 57.2h22.9M252.9 28.9 269.1 45M293.3 69.3l16.2 16.2M252.9 85.5l16.2-16.2M293.3 45l16.2-16.1"
                stroke="#6848D4"
                strokeWidth={4}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity={0.4}
                d="M206.7 97.2a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
                fill="#FF5722"
            />
            <path opacity={0.4} d="M38.2 90.2h-7v7h7v-7Z" fill="#01AAB9" />
            <path
                d="m138.214 73.05-36.26 16.889 42.22 90.649 36.26-16.888-42.22-90.65ZM144.2 180.6l19.2-52.5M162.4 172.1l9.4-25.9M135.8 162.5l19.1-52.5M127.3 144.3l19.2-52.5M118.9 126.2 138 73.7M110.4 108.1l9.7-26.6"
                stroke="#FF337C"
                strokeWidth={4}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity={0.4}
                d="m162.4 172.1-17.9 7.8 18.4-50.5 9.1 16.2-9.6 26.5ZM135.8 162.5l-8.2-18.8L146 93.2l9.2 16.1-19.4 53.2ZM118.9 126.2l-8.2-18.8L121.5 82l16.8-8.9-19.4 53.1Z"
                fill="#FF337C"
            />
            <path
                d="m144.2 180.6 7.2 15.4M154.8 203.3l3.8 8.1M162.4 219.6l1.2 2.7M149.1 68l-42.5-15.5L91.1 95l58-27ZM236.411 152.883l-16.57-5.309-13.241 41.33 16.57 5.309 13.241-41.33ZM209.3 180.7l21.5-11.1M214.601 164.2l21.5-11.1M206.6 189l-5.2 15.6"
                stroke="#FF337C"
                strokeWidth={4}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="m241.4 154.5-9-17.5-17.5 9 26.5 8.5Z"
                stroke="#FF337C"
                strokeWidth={4}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity={0.16}
                d="M53 19.8c-1.9 0-3.7.4-5.4 1-4-4.6-10-7.6-16.6-7.6-7.7 0-14.5 4-18.4 10h-.4c-6.6 0-12 5.4-12 12h68.2c0-8.5-6.9-15.4-15.4-15.4Z"
                fill="#2278ED"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" transform="translate(.2)" d="M0 0h363.6v224.3H0z" />
            </clipPath>
        </defs>
    </svg>
);
